<template>
  <div v-show="showFlag">
    <a href="javascript:void(0)" class="top" @click="toTop">
      <img v-lazy="require('../../styles/common/img/top.png')" alt="" />
    </a>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  name: 'topBtn',
  data() {
    return {
      showFlag: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (document.documentElement.scrollTop <= 100) {
        this.showFlag = false;
      } else {
        this.showFlag = true;
      }
    },
    toTop() {
      let top = document.documentElement.scrollTop;
      const timeTop = setInterval(() => {
        document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop); //清除定时器
        }
      }, 20);
    }
  }
};
</script>

<style lang="scss" scoped>
.top {
  position: fixed;
  width: 2.85rem;
  height: 2.85rem;
  right: 1.25rem;
  bottom: 2.5rem;
  z-index: 5;
}
.top img {
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// topBtn.vue